// eslint-disable-next-line import/prefer-default-export
export const LOAD_ABMUSTERUNGGRUENDE = 'load_abmusterunggruende';
export const LOAD_ABMUSTERUNGABTEILUNGEN = 'load_abmusterungabteilungen';
export const LOAD_STATISTIK = 'load_statistik';
